import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for deviceMarkerTypes.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.DEVICE_MARKER_TYPES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const DeviceMarkerTypeService = {
  FindMany
}

export default DeviceMarkerTypeService
